var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcmInfographic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 408.87 259.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        font-family: Calibri, Calibri;\n        font-size: 9.26px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #0c344a;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-11 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-13 {\n        letter-spacing: .02em;\n      }\n\n      .cls-14 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-15 {\n        letter-spacing: .05em;\n      }\n\n      .cls-16 {\n        letter-spacing: .11em;\n      }\n\n      .cls-17 {\n        letter-spacing: 0em;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-21 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-23 {\n        letter-spacing: .01em;\n      }\n\n      .cls-24 {\n        letter-spacing: .03em;\n      }\n\n      .cls-25 {\n        letter-spacing: .16em;\n      }\n\n      .cls-26 {\n        letter-spacing: 0em;\n      }\n\n      .cls-27 {\n        letter-spacing: .03em;\n      }\n\n      .cls-28 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-31 {\n        letter-spacing: .03em;\n      }\n\n      .cls-32 {\n        letter-spacing: .11em;\n      }\n\n      .cls-33 {\n        letter-spacing: 0em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-35 {\n        fill: #6d66d2;\n      }\n\n      .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40 {\n        fill-rule: evenodd;\n      }\n\n      .cls-41 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42 {\n        letter-spacing: 0em;\n      }\n\n      .cls-43 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        font-family: Calibri-Bold, Calibri;\n        font-size: 10.29px;\n        font-weight: 700;\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-46 {\n        letter-spacing: .01em;\n      }\n\n      .cls-47 {\n        letter-spacing: 0em;\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-36 {\n        fill: #4caefd;\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-51 {\n        letter-spacing: .02em;\n      }\n\n      .cls-52 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-55 {\n        letter-spacing: .01em;\n      }\n\n      .cls-56 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-59 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-60 {\n        letter-spacing: 0em;\n      }\n\n      .cls-61 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-62 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-63 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-64 {\n        letter-spacing: 0em;\n      }\n\n      .cls-65 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-66 {\n        letter-spacing: 0em;\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-69 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-71 {\n        letter-spacing: 0em;\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-73 {\n        letter-spacing: 0em;\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-75 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-77 {\n        letter-spacing: 0em;\n      }\n\n      .cls-78 {\n        letter-spacing: .02em;\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-81 {\n        letter-spacing: 0em;\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-83 {\n        letter-spacing: 0em;\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-85 {\n        letter-spacing: .01em;\n      }\n\n      .cls-86 {\n        letter-spacing: 0em;\n      }\n\n      .cls-37 {\n        fill: #846cfa;\n      }\n\n      .cls-87 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-88 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-89 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-38 {\n        fill: #71c7fe;\n      }\n\n      .cls-90 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-91 {\n        letter-spacing: 0em;\n      }\n\n      .cls-92 {\n        letter-spacing: .02em;\n      }\n\n      .cls-93 {\n        letter-spacing: 0em;\n      }\n\n      .cls-94 {\n        letter-spacing: 0em;\n      }\n\n      .cls-95 {\n        letter-spacing: .02em;\n      }\n\n      .cls-96 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-97 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-98 {\n        letter-spacing: 0em;\n      }\n\n      .cls-99 {\n        letter-spacing: .01em;\n      }\n\n      .cls-100 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-101 {\n        letter-spacing: 0em;\n      }\n\n      .cls-102 {\n        letter-spacing: 0em;\n      }\n\n      .cls-103 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-104 {\n        letter-spacing: 0em;\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-106 {\n        letter-spacing: .01em;\n      }\n\n      .cls-107 {\n        letter-spacing: .02em;\n      }\n\n      .cls-108 {\n        letter-spacing: 0em;\n      }\n\n      .cls-109 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-110 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-111 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-113 {\n        letter-spacing: 0em;\n      }\n\n      .cls-114 {\n        letter-spacing: 0em;\n      }\n\n      .cls-115 {\n        letter-spacing: 0em;\n      }\n\n      .cls-116 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-117 {\n        letter-spacing: 0em;\n      }\n\n      .cls-118 {\n        clip-rule: evenodd;\n      }\n\n      .cls-118, .cls-119, .cls-120 {\n        fill: none;\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-122 {\n        letter-spacing: 0em;\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-124 {\n        letter-spacing: 0em;\n      }\n\n      .cls-125 {\n        letter-spacing: 0em;\n      }\n\n      .cls-126 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-127 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-129 {\n        letter-spacing: 0em;\n      }\n\n      .cls-130 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-131 {\n        letter-spacing: .03em;\n      }\n\n      .cls-132 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-133 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-120 {\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: .98px;\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-136 {\n        letter-spacing: .11em;\n      }\n\n      .cls-137 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-139 {\n        letter-spacing: 0em;\n      }\n\n      .cls-39 {\n        fill: #717dfb;\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-142 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-143 {\n        letter-spacing: 0em;\n      }\n\n      .cls-144 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-145 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-146 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-148 {\n        letter-spacing: .05em;\n      }\n\n      .cls-149 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-151 {\n        letter-spacing: .05em;\n      }\n\n      .cls-152 {\n        letter-spacing: 0em;\n      }\n\n      .cls-153 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-154 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-155 {\n        letter-spacing: 0em;\n      }\n\n      .cls-156 {\n        letter-spacing: .01em;\n      }\n\n      .cls-157 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-158 {\n        letter-spacing: .16em;\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-160 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-163 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-166 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-167 {\n        letter-spacing: -.12em;\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-40 {\n        fill: #efefef;\n      }\n\n      .cls-169 {\n        letter-spacing: 0em;\n      }\n\n      .cls-170 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-171 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-172 {\n        letter-spacing: .02em;\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-66);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 158.2,
    y: 28.03,
    width: 85.83,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "158.2 87.17 244.03 87.17 244.03 28.03 158.2 28.03 158.2 87.17 158.2 87.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 158.2,
    y: 28.03,
    width: 85.83,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "158.2 87.17 244.03 87.17 244.03 28.03 158.2 28.03 158.2 87.17 158.2 87.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 158.2,
    y: 28.03,
    width: 85.83,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "158.2 87.17 244.03 87.17 244.03 28.03 158.2 28.03 158.2 87.17 158.2 87.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 158.2,
    y: 28.03,
    width: 85.83,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "10.65 134.74 95.98 134.74 95.98 68.91 10.65 68.91 10.65 134.74 10.65 134.74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 10.65,
    y: 68.91,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "283.17 96.42 308.06 96.42 308.06 71.22 283.17 71.22 283.17 96.42 283.17 96.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "283.17 96.42 308.06 96.42 308.06 71.22 283.17 71.22 283.17 96.42 283.17 96.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "92.81 96.17 117.69 96.17 117.69 70.97 92.81 70.97 92.81 96.17 92.81 96.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "92.81 96.17 117.69 96.17 117.69 70.97 92.81 70.97 92.81 96.17 92.81 96.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "131.71 147.34 156.6 147.34 156.6 122.14 131.71 122.14 131.71 147.34 131.71 147.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "131.71 147.34 156.6 147.34 156.6 122.14 131.71 122.14 131.71 147.34 131.71 147.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 66.43,
    y: 158.36,
    width: 87.35,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "66.43 212.36 153.78 212.36 153.78 158.36 66.43 158.36 66.43 212.36 66.43 212.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 66.43,
    y: 158.36,
    width: 87.35,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "66.43 212.36 153.78 212.36 153.78 158.36 66.43 158.36 66.43 212.36 66.43 212.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 66.43,
    y: 158.36,
    width: 87.35,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "66.43 212.36 153.78 212.36 153.78 158.36 66.43 158.36 66.43 212.36 66.43 212.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 66.43,
    y: 158.36,
    width: 87.35,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 168.92,
    y: 185.36,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "168.92 251.19 254.24 251.19 254.24 185.36 168.92 185.36 168.92 251.19 168.92 251.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 168.92,
    y: 185.36,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "168.92 251.19 254.24 251.19 254.24 185.36 168.92 185.36 168.92 251.19 168.92 251.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 168.92,
    y: 185.36,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "168.92 251.19 254.24 251.19 254.24 185.36 168.92 185.36 168.92 251.19 168.92 251.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 168.92,
    y: 185.36,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "168.92 251.19 254.24 251.19 254.24 185.36 168.92 185.36 168.92 251.19 168.92 251.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 168.92,
    y: 185.36,
    width: 85.32,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 254.24,
    y: 155.83,
    width: 86.34,
    height: 65.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "254.24 221.14 340.58 221.14 340.58 155.83 254.24 155.83 254.24 221.14 254.24 221.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 254.24,
    y: 155.83,
    width: 86.34,
    height: 65.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "254.24 221.14 340.58 221.14 340.58 155.83 254.24 155.83 254.24 221.14 254.24 221.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 254.24,
    y: 155.83,
    width: 86.34,
    height: 65.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "254.24 221.14 340.58 221.14 340.58 155.83 254.24 155.83 254.24 221.14 254.24 221.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 254.24,
    y: 155.83,
    width: 86.34,
    height: 65.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "254.24 221.14 340.58 221.14 340.58 155.83 254.24 155.83 254.24 221.14 254.24 221.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 254.24,
    y: 155.83,
    width: 86.34,
    height: 65.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "323.04 137.83 408.87 137.83 408.87 72 323.04 72 323.04 137.83 323.04 137.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "323.04 137.83 408.87 137.83 408.87 72 323.04 72 323.04 137.83 323.04 137.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "323.04 137.83 408.87 137.83 408.87 72 323.04 72 323.04 137.83 323.04 137.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "323.04 137.83 408.87 137.83 408.87 72 323.04 72 323.04 137.83 323.04 137.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "323.04 137.83 408.87 137.83 408.87 72 323.04 72 323.04 137.83 323.04 137.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "323.04 137.83 408.87 137.83 408.87 72 323.04 72 323.04 137.83 323.04 137.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 323.04,
    y: 72,
    width: 85.83,
    height: 65.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "247.34 147.34 271.71 147.34 271.71 122.14 247.34 122.14 247.34 147.34 247.34 147.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "247.34 147.34 271.71 147.34 271.71 122.14 247.34 122.14 247.34 147.34 247.34 147.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "188.61 165.44 213.5 165.44 213.5 140.24 188.61 140.24 188.61 165.44 188.61 165.44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "188.61 165.44 213.5 165.44 213.5 140.24 188.61 140.24 188.61 165.44 188.61 165.44"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crop_Marks",
    "data-name": "Crop Marks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M18.03,143.57C9.59,126.16,3.66,107.67,.39,88.52c-2.76-16.14,9.48-30.92,25.65-30.92H106.67c25.22,0,35.71,32.69,15.31,47.71l-65.24,48.01c-13.09,9.63-31.57,4.96-38.7-9.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M295.26,57.6h80.63c16.18,0,28.41,14.78,25.65,30.92-3.27,19.15-9.2,37.64-17.64,55.05-7.13,14.71-25.61,19.38-38.7,9.75l-65.24-48.01c-20.41-15.02-9.92-47.71,15.31-47.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M274.64,112.65l65.34,48.12c13.12,9.66,14.46,28.98,2.81,40.41-6.79,6.66-14.04,12.85-21.71,18.53-7.83,5.8-16.03,11-24.53,15.58-14.34,7.73-32.09,.49-37.11-15.17l-24.97-77.89c-7.81-24.37,19.71-44.64,40.16-29.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M201.05,259.14c-9.64,0-19.21-.67-28.67-2.02-16.12-2.29-26.3-18.74-21.27-34.4l25.04-77.92c7.84-24.39,41.96-24.39,49.79,0l25.04,77.92c5.03,15.66-5.14,32.11-21.27,34.4-9.45,1.34-19.03,2.02-28.67,2.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M142.59,220.13c-5.02,15.66-22.77,22.9-37.11,15.17-8.5-4.58-16.69-9.78-24.53-15.58-7.67-5.68-14.92-11.87-21.71-18.53-11.65-11.43-10.3-30.75,2.81-40.41l65.34-48.12c20.45-15.06,47.98,5.21,40.16,29.58l-24.97,77.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M221.94,153.77c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M280.35,134.74c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M316.91,84.08c0,11.5-9.32,20.83-20.82,20.83s-20.82-9.33-20.82-20.83,9.32-20.83,20.82-20.83,20.82,9.33,20.82,20.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M126.97,84.08c0,11.5-9.32,20.83-20.82,20.83s-20.82-9.33-20.82-20.83,9.32-20.83,20.82-20.83,20.82,9.33,20.82,20.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M163.03,134.74c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M221.94,110.03c-.88,0-1.66-.56-1.93-1.4-.34-1.04,.18-2.14,1.18-2.52,9.34-3.57,17.62-9.59,23.92-17.42,.38-.47,.95-.74,1.56-.74,.43,0,.84,.13,1.19,.39,.45,.33,.74,.82,.81,1.37,.07,.56-.08,1.11-.44,1.56-6.75,8.37-15.59,14.81-25.55,18.64-.24,.09-.48,.14-.73,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M249.86,87.26c-.43,0-.83-.13-1.18-.39-.87-.64-1.1-1.84-.51-2.74,5.47-8.41,8.62-18.17,9.1-28.23,.05-1.07,.93-1.9,2.01-1.9,.58,0,1.1,.22,1.48,.63,.39,.41,.59,.96,.56,1.53-.53,10.74-3.91,21.18-9.77,30.19-.38,.58-1.01,.93-1.7,.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M201.07,114.12c-5.32,0-10.62-.71-15.72-2.1-.54-.15-.99-.5-1.26-1-.26-.49-.32-1.06-.14-1.59,.28-.86,1.04-1.42,1.91-1.42,.17,0,.35,.02,.52,.07,4.77,1.3,9.71,1.96,14.7,1.96s9.93-.66,14.7-1.96c.17-.05,.35-.07,.52-.07,.87,0,1.63,.56,1.9,1.4,.18,.55,.13,1.12-.14,1.61-.27,.5-.71,.85-1.26,1-5.11,1.39-10.4,2.1-15.72,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M152.15,87.27c-.69,0-1.32-.35-1.7-.93-5.86-9.01-9.24-19.44-9.77-30.19-.03-.57,.17-1.12,.56-1.53,.38-.4,.9-.63,1.45-.63,1.1,0,1.99,.84,2.04,1.9,.49,10.06,3.64,19.82,9.1,28.24,.58,.9,.36,2.1-.51,2.74l-.04,.03c-.31,.23-.72,.36-1.14,.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M180.12,110.03c-.25,0-.5-.05-.73-.14-9.97-3.82-18.81-10.27-25.55-18.64-.35-.44-.51-.99-.44-1.56,.07-.55,.36-1.04,.81-1.37,.35-.25,.76-.39,1.19-.39,.61,0,1.18,.27,1.56,.74,6.3,7.83,14.57,13.86,23.92,17.42,1,.38,1.52,1.48,1.18,2.51-.27,.85-1.05,1.41-1.93,1.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M253.43,52.97c0,29.26-23.42,52.97-52.31,52.97s-52.31-23.72-52.31-52.97S172.23,0,201.12,0s52.31,23.72,52.31,52.97h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(168.94 40.99) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 4.63,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 8.23,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 13.37,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-152",
    x: 19.03,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-142",
    x: 23.14,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 26.23,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 31.88,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-63",
    x: 35.49,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 43.72,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-167",
    x: 45.78,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-99",
    x: 49.9,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 55.55,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 61.21,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.81,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(182.14 53.33) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-139",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 4.64,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 7.21,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 12.86,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 18,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 23.65,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 27.77,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-143",
    x: 30.34,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 35.48,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-73",
    x: 38.04,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(166.4 65.67) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 0,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 7.19,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 12.85,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 17.99,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 21.6,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 26.74,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 32.8,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 38.45,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-152",
    x: 44.11,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-127",
    x: 48.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-169",
    x: 49.76,
    y: 0
  }, "wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-115",
    x: 60.04,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 63.63,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-73",
    x: 69.29,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(179.09 78.02) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 9.26,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 11.84,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 16.47,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 21.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 24.18,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 29.84,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.49,
    y: 0
  }, "M"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(16.76 80.79) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 5.14,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 9.76,
    y: 0
  }, "du"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 19.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 23.14,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 27.76,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 30.32,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 34.96,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 39.58,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 44.21,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 46.27,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 50.89,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 52.95,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 56.55,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(16.76 92.11) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 6.68,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 8.74,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 11.83,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 16.47,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 19.03,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.17,
    y: 0
  }, "I"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(43.16 92.11) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(46.21 92.11) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 0,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 4.63,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 7.72,
    y: 0
  }, "iv"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 13.9,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 18.52,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 23.15,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(16.76 103.42) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 4.12,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 8.74,
    y: 0
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 12.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 17.49,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 22.11,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 27.2,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 32.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-151",
    x: 36.97,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 39.54,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-88",
    x: 44.16,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-151",
    x: 53.42,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 55.99,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 59.07,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 63.7,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 68.32,
    y: 0
  }, "l"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(86.33 103.42) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(16.76 114.74) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 5.09,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 12.29,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-148",
    x: 16.92,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 19.48,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 23.59,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 25.65,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 30.27,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 32.33,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 39.53,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(16.76 126.04) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 0,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 3.6,
    y: 0
  }, "ub"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 12.87,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 20.07,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 22.13,
    y: 0
  }, "ss"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 29.33,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 31.39,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 36.53,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.16,
    y: 0
  }, "s"))))))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M306.03,73.59c-.54,0-1.01,.35-1.18,.87h-1.09c-.1,0-.2,.04-.27,.12l-1.89,1.92c-3.95-3.52-9.97-3.12-13.45,.88-3.43,3.96-3.1,9.97,.75,13.51l-1.48,1.5h-1.04c-.21-.66-.92-1.03-1.58-.81-.66,.22-1.01,.93-.8,1.6,.21,.66,.92,1.03,1.58,.81,.38-.13,.67-.43,.8-.81h1.2c.1,0,.2-.04,.27-.12l1.64-1.66c4.17,3.25,10.15,2.47,13.36-1.75,2.89-3.79,2.59-9.16-.7-12.6l1.77-1.79h.92c.22,.66,.92,1.02,1.57,.8,.65-.22,1-.93,.79-1.59-.17-.51-.64-.86-1.18-.86h0Zm-20.83,19.66c-.26,0-.47-.21-.47-.48,0-.26,.21-.48,.47-.48,.26,0,.47,.21,.47,.47h0c0,.27-.21,.48-.47,.48h0Zm16.9-9.91c-.2-3.5-2.96-6.29-6.41-6.49v-1.97c4.53,.21,8.15,3.88,8.36,8.46h-1.94Zm-5.53,6.37v-3.23h1v2.91c-.32,.13-.66,.24-1,.31h0Zm-1.28,.14c-.17,0-.34-.01-.5-.03v-9.07h1v9.07c-.17,.01-.33,.03-.5,.03h0Zm-2.28-.45v-4.49h1v4.81c-.34-.07-.68-.18-1-.31h0Zm-1.78-1.14v-1.29h1v2.04c-.36-.21-.69-.46-1-.75h0Zm7.11-2.17v-3h1v5.17c-.31,.28-.64,.53-1,.75v-2.91Zm1.39-3.79h-1.78c-.21,0-.39,.18-.39,.39v3h-1v-5.33c0-.22-.17-.39-.39-.39h-1.78c-.21,0-.39,.18-.39,.39v3.75h-1.39c-.21,0-.39,.18-.39,.39v1.67h-1.39c-.21,0-.39,.18-.39,.39v.82c-2.01-2.7-1.47-6.54,1.2-8.57,2.67-2.03,6.46-1.49,8.47,1.22,1.62,2.18,1.62,5.18,0,7.35v-4.7c0-.22-.17-.39-.39-.39h0Zm-4.83-7.42v1.96c-3.46,.2-6.21,3-6.41,6.49h-1.94c.21-4.58,3.83-8.25,8.36-8.46h0Zm.39,17.72c-4.68,0-8.53-3.74-8.75-8.47h1.94c.1,1.74,.84,3.37,2.07,4.58,.01,.01,.02,.02,.04,.03,.54,.52,1.17,.95,1.85,1.27,.01,0,.03,.01,.04,.02,.6,.27,1.23,.46,1.89,.55,0,0,.02,0,.02,0h0c.59,.09,1.19,.09,1.77,0h0s.01,0,.02,0c.65-.09,1.29-.27,1.89-.55,.01,0,.03-.01,.04-.02,.68-.32,1.3-.75,1.85-1.27,.02-.01,.03-.03,.04-.04,1.24-1.2,1.97-2.84,2.07-4.57h1.94c-.21,4.74-4.06,8.47-8.75,8.47h0Zm10.73-17.26c-.26,0-.47-.21-.47-.48,0-.26,.21-.48,.47-.48,.26,0,.47,.21,.47,.48,0,.26-.21,.48-.47,.48h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.55,82.51c-.07-.08-.18-.12-.28-.12h-5.52c-.21,0-.39,.18-.39,.39v11.81c0,.22,.17,.39,.39,.39h7.78c.21,0,.39-.18,.39-.39v-9.39c0-.1-.04-.2-.1-.27l-2.26-2.42Zm.03,1.18l.99,1.06h-.99v-1.06h0Zm-5.44,10.51v-11.02h4.67v1.97c0,.22,.17,.39,.39,.39h1.94v8.66h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M112.24,87.11c.21,0,.39-.18,.39-.39v-2.36c0-.22-.17-.39-.39-.39h-2.33c-.21,0-.39,.18-.39,.39v2.36c0,.22,.17,.39,.39,.39h2.33Zm-1.94-2.36h1.56v1.57h-1.56v-1.57h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "113.02 86.32 115.35 86.32 115.35 87.11 113.02 87.11 113.02 86.32 113.02 86.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.91 88.29 115.35 88.29 115.35 89.08 109.91 89.08 109.91 88.29 109.91 88.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M95.53,78.06h1.56v1.57h-1.56v.79h3.89v-.79h-1.56v-1.57h1.56c1.07,0,1.94-.88,1.94-1.97v-2.36c0-1.09-.87-1.97-1.94-1.97h-3.89c-1.07,0-1.94,.88-1.94,1.97v2.36c0,1.09,.87,1.97,1.94,1.97h0Zm-1.17-4.33c0-.65,.52-1.18,1.17-1.18h3.89c.64,0,1.17,.53,1.17,1.18v2.36c0,.65-.52,1.18-1.17,1.18h-3.89c-.64,0-1.17-.53-1.17-1.18v-2.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.91 90.26 115.35 90.26 115.35 91.05 109.91 91.05 109.91 90.26 109.91 90.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.91 92.23 115.35 92.23 115.35 93.01 109.91 93.01 109.91 92.23 109.91 92.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100.66,79.73l-.8,1.36c-.05,.09-.07,.2-.04,.3,.03,.1,.1,.19,.19,.24l.47,.27c-.04,.19-.05,.38-.05,.58,0,.13,0,.26,.02,.39l-.44,.25c-.09,.05-.16,.14-.19,.24-.03,.1-.01,.21,.04,.3l.8,1.36c.11,.18,.34,.25,.52,.14l.36-.2c.29,.26,.63,.46,.98,.61v.35c0,.22,.17,.39,.39,.39h1.59c.21,0,.39-.18,.39-.39v-.28c.4-.13,.76-.34,1.08-.61l.24,.14c.18,.1,.42,.04,.52-.14l.78-1.36c.05-.09,.07-.2,.04-.3-.03-.1-.1-.19-.19-.24l-.26-.15c.03-.17,.04-.33,.04-.5,0-.23-.02-.46-.07-.68l.29-.17c.09-.05,.16-.14,.19-.24,.03-.1,.01-.21-.04-.3l-.78-1.36c-.11-.18-.34-.25-.52-.14l-.39,.22c-.29-.21-.6-.38-.94-.49v-.48c0-.22-.17-.39-.39-.39h-1.59c-.21,0-.39,.18-.39,.39v.55c-.3,.12-.57,.29-.82,.49l-.5-.29c-.18-.11-.42-.06-.54,.13,0,0,0,.01,0,.02h0Zm1.34,.91c.29-.27,.64-.48,1.02-.6,.17-.05,.28-.22,.27-.39v-.41h.82v.39c0,.19,.12,.35,.3,.39,.42,.1,.8,.3,1.12,.58,.12,.11,.3,.13,.45,.05l.28-.17,.39,.68-.2,.12c-.16,.09-.23,.28-.18,.46,.07,.24,.11,.5,.11,.76,0,.2-.03,.41-.08,.61-.04,.17,.03,.35,.19,.44l.16,.09-.39,.68-.15-.09c-.15-.09-.34-.06-.47,.06-.34,.34-.77,.58-1.24,.68-.18,.04-.3,.21-.3,.39v.15h-.8v-.23c0-.18-.1-.34-.27-.39-.43-.13-.82-.38-1.13-.71-.12-.13-.32-.16-.47-.07l-.28,.16-.39-.68,.33-.19c.15-.08,.23-.26,.19-.43-.04-.17-.05-.35-.05-.52,0-.23,.03-.45,.09-.67,.05-.17-.03-.36-.18-.45l-.39-.22,.39-.68,.41,.23c.14,.08,.32,.07,.45-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.67,75.69h-.39c-.11,0-.19-.09-.19-.2h-.78c0,.48,.32,.89,.78,.98v.39h.78v-.39c.54-.05,.93-.54,.87-1.08-.05-.54-.53-.94-1.07-.89h-.39c-.11,0-.19-.09-.19-.2s.09-.2,.19-.2h.39c.11,0,.19,.09,.19,.2h.78c0-.47-.32-.87-.78-.96v-.41h-.78v.39c-.54,.05-.93,.54-.87,1.08s.53,.94,1.07,.89h.39c.11,0,.19,.09,.19,.2s-.09,.2-.19,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.86,92.23v-7.87h.78c.21,0,.39-.18,.39-.39,0-.06-.01-.12-.04-.18l-1.17-2.36c-.1-.19-.33-.27-.52-.17-.07,.04-.13,.1-.17,.17l-1.17,2.36c-.1,.19-.02,.43,.17,.53,.05,.03,.11,.04,.17,.04h.78v7.87c0,1.52,1.22,2.76,2.72,2.76h7.78v-.79h-7.78c-1.07,0-1.94-.88-1.94-1.97h0Zm-.39-9.75l.54,1.09h-1.07l.54-1.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M112.24,74.51v3.94h-.78c-.21,0-.39,.18-.39,.39,0,.06,.01,.12,.04,.18l1.17,2.36c.1,.19,.33,.27,.52,.17,.07-.04,.13-.1,.17-.17l1.17-2.36c.1-.19,.02-.43-.17-.53-.05-.03-.11-.04-.17-.04h-.78v-3.94c0-1.52-1.22-2.76-2.72-2.76h-8.16v.79h8.16c1.07,0,1.94,.88,1.94,1.97h0Zm.39,5.81l-.54-1.09h1.07l-.54,1.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.69,84.35c1.07,0,1.94-.88,1.94-1.97s-.87-1.97-1.94-1.97-1.94,.88-1.94,1.97,.87,1.97,1.94,1.97h0Zm0-3.15c.64,0,1.17,.53,1.17,1.18s-.52,1.18-1.17,1.18-1.17-.53-1.17-1.18,.52-1.18,1.17-1.18h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M149.43,143.75h-2.02c-.54,0-.97,.44-.97,.98v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M149.5,128.62v-3.82c0-.54-.44-.98-.97-.98h-3.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-120",
    points: "141.59 146.85 146.44 146.85 149.5 143.75 149.5 140.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M136.91,123.81h-3.74c-.54,0-.97,.44-.97,.98v21.07c0,.54,.44,.98,.97,.98h4.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M143.94,125.39h-6.18c-.31,0-.56-.26-.56-.57v-2.19h7.31v2.19c0,.31-.25,.57-.56,.57h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-120",
    points: "135.46 136.16 136.33 137.04 138.36 134.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-120",
    x1: 140.83,
    y1: 137.04,
    x2: 143.12,
    y2: 137.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-120",
    x1: 140.83,
    y1: 134.88,
    x2: 145.23,
    y2: 134.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-120",
    points: "135.46 141.53 136.33 142.41 138.36 140.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-120",
    x1: 140.83,
    y1: 142.41,
    x2: 144.16,
    y2: 142.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-120",
    x1: 140.83,
    y1: 140.25,
    x2: 145.2,
    y2: 140.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-120",
    points: "135.46 130.8 136.33 131.68 138.36 129.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-120",
    x1: 140.83,
    y1: 131.67,
    x2: 143.01,
    y2: 131.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-120",
    x1: 140.83,
    y1: 129.51,
    x2: 146.24,
    y2: 129.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M147.17,131.42v3.16c0,2.18,1.45,4.08,3.5,4.65,2.05-.57,3.5-2.47,3.5-4.65v-3.16l-3.5-1.11-3.5,1.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M150.67,128.25l5.44,1.72v4.6c0,3.26-2.28,6.06-5.44,6.67h0c-3.16-.61-5.44-3.41-5.44-6.67v-4.6l5.44-1.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-120",
    points: "149.11 134.62 150.23 135.75 152.22 133.74"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.59 170.04) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-100",
    x: 0,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 5.15,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 9.78,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 12.86,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 14.92,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 18.01,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 22.12,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 24.69,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 29.32,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 33.94,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 39.03,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-88",
    x: 43.66,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 48.29,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.38,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.59 181.35) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 0,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 4.62,
    y: 0
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 8.74,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 12.86,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 14.92,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 19.55,
    y: 0
  }, "ili"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 25.73,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 28.82,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-158",
    x: 32.94,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 36.53,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 41.15,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 50.41,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.59 192.66) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 2.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 6.69,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 10.29,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 14.93,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 18.01,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 22.63,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 27.27,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 31.38,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-136",
    x: 36,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-172",
    x: 39.08,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 43.19,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 48.33,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 52.45,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 57.07,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-92",
    x: 60.16,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 64.78,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 68.9,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.52,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.59 203.98) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 2.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 6.69,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 10.29,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 13.39,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 18,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 22.64,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 25.73,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.79,
    y: 0
  }, "y"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(175.03 197.23) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-156",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 4.62,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 7.71,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 12.33,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 16.44,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 20.55,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 22.62,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 27.25,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 31.88,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 36.51,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 38.57,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 43.19,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 45.25,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 48.85,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 50.91,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(175.03 208.55) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 2.06,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 6.69,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 11.32,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 15.95,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 21.04,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 24.13,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 28.24,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 31.32,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 34.41,
    y: 0
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 44.69,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 47.79,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(175.03 219.86) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 4.11,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 8.73,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 13.36,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 16.96,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 21.59,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 25.19,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 27.25,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 29.81,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 34.43,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 43.7,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(175.03 231.19) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 4.62,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 9.25,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 12.34,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 17.48,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 24.68,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 29.3,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 32.4,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 37.02,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 39.58,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 42.68,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 47.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 51.93,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(175.03 242.49) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 4.62,
    y: 0
  }, "pp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 13.88,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 18.51,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 23.13,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-148",
    x: 25.19,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 27.75,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 32.38,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 35.47,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-172",
    x: 40.61,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 44.72,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 49.35,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.95,
    y: 0
  }, "s")))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(260.39 167.46) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 4.11,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 8.74,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 13.36,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 20.56,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 22.62,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 27.24,
    y: 0
  }, "ss"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 34.45,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 36.51,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-136",
    x: 40.62,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 43.71,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 46.79,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-172",
    x: 51.42,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 55.53,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 60.67,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-88",
    x: 63.76,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.39,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(260.39 178.76) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 0,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 4.63,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 9.25,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 13.37,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 20.57,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 25.19,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 29.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 32.92,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 36.52,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 39.6,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 44.22,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.49,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(260.39 190.08) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 0,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 7.2,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 11.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 14.91,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 19.02,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 23.65,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 26.22,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 29.31,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 32.4,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 37.02,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 41.65,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 45.25,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-172",
    x: 49.87,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 53.98,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 59.07,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 64.21,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 68.84,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.45,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(260.39 201.4) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "fo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 8.23,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 11.31,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 13.38,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 18,
    y: 0
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 26.22,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 30.85,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 33.94,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 38.56,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 41.65,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 46.27,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(260.39 212.71) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 4.62,
    y: 0
  }, "cc"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 12.84,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 17.98,
    y: 0
  }, "un"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 27.24,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 32.33,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 36.97,
    y: 0
  }, "g")))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(329.25 83.87) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-69",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 5.66,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 10.28,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 12.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 16.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 19.54,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 22.63,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 27.25,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.87,
    y: 0
  }, "l"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(362.76 83.87) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(365.81 83.87) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 0,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 5.09,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 12.29,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.92,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(329.25 95.19) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 0,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 2.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 6.69,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 10.29,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 12.35,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 16.47,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 21.1,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 24.19,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 27.8,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 30.88,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 32.94,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 37.57,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 40.66,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.8,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(329.25 106.5) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 0,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 3.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 7.71,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 11.83,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 16.45,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 25.72,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 30.34,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 33.93,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 37.03,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 40.12,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 44.74,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 54,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.61,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(329.25 117.82) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 4.62,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-148",
    x: 13.88,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 16.45,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 20.56,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 25.18,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 28.78,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 33.41,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 35.48,
    y: 0
  }, "fl"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 40.31,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 45.45,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.13,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(329.25 129.13) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-133",
    x: 5.14,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 9.77,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-154",
    x: 14.87,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 22.07,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-155",
    x: 24.13,
    y: 0
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 27.73,
    y: 0
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-94",
    x: 32.35,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 37.44,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.58,
    y: 0
  }, "n")))))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M258.88,136.63c-2.2,0-3.99-1.85-3.99-4.13s1.79-4.13,3.99-4.13c.21,0,.38-.18,.38-.39v-5.05c0-.22-.17-.39-.38-.39h-1.25c-.16,0-.3,.1-.36,.25l-.52,1.4c-.72,.2-1.41,.49-2.06,.88l-1.32-.61c-.14-.07-.31-.03-.42,.08l-1.77,1.83c-.11,.12-.14,.29-.08,.44l.59,1.37c-.38,.67-.66,1.38-.85,2.13l-1.35,.54c-.15,.06-.24,.2-.24,.37v2.59c0,.16,.1,.31,.24,.37l1.35,.54c.19,.74,.48,1.46,.85,2.13l-.59,1.37c-.06,.15-.03,.32,.08,.44l1.77,1.83c.11,.12,.28,.15,.42,.08l1.32-.61c.65,.39,1.34,.68,2.06,.88l.52,1.4c.06,.15,.2,.25,.36,.25h1.25c.21,0,.38-.18,.38-.39v-5.05c0-.22-.17-.39-.38-.39h0Zm-.38,5.05h-.61l-.5-1.33c-.05-.12-.15-.21-.27-.24-.78-.19-1.52-.51-2.2-.94-.11-.07-.24-.08-.35-.02l-1.26,.58-1.4-1.45,.56-1.31c.05-.12,.04-.26-.02-.37-.42-.71-.73-1.47-.91-2.28-.03-.13-.12-.23-.23-.28l-1.29-.51v-2.05l1.29-.51c.12-.05,.2-.15,.23-.28,.19-.8,.49-1.57,.91-2.28,.07-.11,.07-.25,.02-.37l-.56-1.31,1.4-1.45,1.26,.58c.11,.05,.25,.04,.35-.02,.68-.43,1.42-.75,2.2-.94,.12-.03,.22-.12,.27-.24l.5-1.33h.61v4.28c-2.44,.2-4.37,2.32-4.37,4.9s1.93,4.7,4.37,4.9v4.28Zm11.07-10.84l-1.35-.54c-.19-.74-.48-1.46-.85-2.13l.59-1.37c.06-.15,.03-.32-.08-.44l-1.77-1.83c-.11-.12-.28-.15-.42-.08l-1.32,.61c-.65-.39-1.34-.68-2.06-.88l-.52-1.4c-.06-.15-.2-.25-.36-.25h-1.25c-.21,0-.38,.18-.38,.39v5.05c0,.22,.17,.39,.38,.39,2.2,0,3.99,1.85,3.99,4.13s-1.79,4.13-3.99,4.13c-.21,0-.38,.18-.38,.39v5.05c0,.22,.17,.39,.38,.39h1.25c.16,0,.3-.1,.36-.25l.52-1.4c.72-.2,1.41-.49,2.06-.88l1.32,.61c.14,.07,.31,.03,.42-.08l1.77-1.83c.11-.12,.14-.29,.08-.44l-.59-1.37c.38-.67,.66-1.38,.85-2.13l1.35-.54c.15-.06,.24-.2,.24-.37v-2.59c0-.16-.1-.31-.24-.37h0Zm-.52,2.69l-1.29,.51c-.12,.05-.2,.15-.23,.28-.19,.8-.49,1.57-.91,2.28-.07,.11-.07,.25-.02,.37l.56,1.31-1.4,1.45-1.26-.58c-.11-.05-.25-.04-.35,.02-.68,.44-1.42,.75-2.2,.94-.12,.03-.22,.12-.27,.24l-.5,1.33h-.61v-4.28c2.44-.2,4.37-2.32,4.37-4.9s-1.93-4.7-4.37-4.9v-4.28h.61l.5,1.33c.05,.12,.15,.21,.27,.24,.78,.19,1.52,.51,2.2,.94,.11,.07,.24,.08,.35,.02l1.26-.58,1.4,1.45-.56,1.31c-.05,.12-.04,.26,.02,.37,.42,.71,.73,1.47,.91,2.28,.03,.13,.12,.23,.23,.28l1.29,.51v2.05h0Zm-5.97-1.03c0-2.03-1.6-3.68-3.56-3.68s-3.56,1.65-3.56,3.68,1.6,3.68,3.56,3.68,3.56-1.65,3.56-3.68h0Zm-3.56,2.89c-1.54,0-2.8-1.3-2.8-2.89s1.25-2.89,2.8-2.89,2.8,1.3,2.8,2.89-1.25,2.89-2.8,2.89h0Zm-3.25,6.22c-.04-.11-.13-.2-.24-.23-.42-.14-.83-.32-1.22-.52-.1-.05-.22-.06-.33,0l-1.52,.7-.59-.61c-.09-.09-.21-.13-.34-.11-.12,.02-.23,.11-.28,.22l-1.58,3.52c-.06,.13-.04,.29,.04,.41,.09,.12,.23,.17,.37,.15l2.24-.4,1.14,2.03c.07,.12,.19,.2,.33,.2,0,0,.01,0,.02,0,.14,0,.27-.09,.33-.23l1.86-4.13c.04-.1,.05-.21,.01-.31l-.25-.67Zm-2,4.09l-.91-1.61c-.07-.12-.2-.2-.33-.2-.02,0-.04,0-.07,0l-1.78,.32,1.05-2.32,.39,.4c.11,.12,.28,.15,.42,.08l1.6-.73c.32,.16,.65,.3,.99,.42l.13,.34-1.48,3.29h0Zm13.01-4.65c-.05-.12-.16-.2-.28-.22-.12-.02-.25,.02-.34,.11l-.59,.61-1.52-.7c-.1-.05-.22-.04-.33,0-.39,.2-.8,.38-1.22,.52-.11,.04-.19,.12-.24,.23l-.25,.67c-.04,.1-.03,.21,.01,.31l1.76,3.91c.06,.13,.19,.22,.33,.23,0,0,.01,0,.02,0,.14,0,.26-.07,.33-.2l1.14-2.03,2.24,.4c.14,.03,.28-.03,.37-.15,.09-.12,.1-.27,.04-.41l-1.49-3.3Zm-1.29,2.63c-.16-.03-.31,.05-.39,.19l-.91,1.61-1.39-3.08,.13-.34c.33-.12,.66-.26,.99-.42l1.6,.73c.14,.07,.31,.03,.42-.08l.39-.4,.95,2.1-1.78-.32h0Zm-4.75-12.39c.14,.16,.13,.41-.03,.56l-2.02,1.9c-.07,.07-.16,.1-.26,.1-.1,0-.2-.04-.27-.12l-.83-.86c-.15-.15-.15-.4,0-.56,.15-.15,.39-.15,.54,0l.58,.6,1.76-1.65c.16-.15,.4-.13,.54,.03h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M202.3,162.48h-1.27v-1.22h1.82c.19,0,.34-.15,.34-.34s-.15-.34-.34-.34h-12.99c-.2,0-.37-.17-.37-.37v-12.73c0-.21,.16-.37,.37-.37h6.02s-.01,.01-.02,.02c-.13,.18-.25,.35-.38,.51h-5.12c-.19,0-.34,.15-.34,.34v11.04c0,.19,.15,.34,.34,.34h12.49c.19,0,.34-.15,.34-.34s-.15-.34-.34-.34h-12.15v-10.35h4.28c-.73,1.04-1.29,2.09-1.29,3.76,0,1.5,.6,2.77,1.73,3.66,.99,.77,2.31,1.2,3.72,1.2s2.73-.43,3.72-1.2c1.13-.89,1.73-2.15,1.73-3.66,0-1.67-.56-2.72-1.29-3.76h4.28v5.71c0,.19,.15,.34,.34,.34s.34-.15,.34-.34v-6.06c0-.19-.15-.34-.34-.34h-5.12c-.12-.17-.25-.34-.38-.51,0,0-.01-.01-.02-.02h6.02c.2,0,.37,.17,.37,.37v6.57c0,.19,.15,.34,.34,.34s.34-.15,.34-.34v-6.57c0-.59-.47-1.06-1.05-1.06h-6.49c-.05-.08-.1-.15-.15-.23,.23-.17,.39-.44,.39-.75,0-.37-.22-.69-.53-.83,.9-1.46,1.15-2.53,.74-3.09-.24-.32-.65-.42-1.14-.27-.36,.11-.59,.31-.76,.45h-.01c-.12,.11-.18,.14-.21,.15-.01-.01-.03-.03-.06-.08-.34-.49-.68-.72-1.05-.72s-.72,.24-1.05,.72c-.03,.04-.05,.07-.06,.08-.03,0-.08-.04-.21-.14h-.01c-.17-.15-.4-.34-.76-.46-.49-.15-.9-.06-1.14,.27-.41,.56-.16,1.63,.74,3.09-.31,.14-.53,.46-.53,.83,0,.31,.15,.58,.39,.75-.05,.07-.1,.15-.15,.23h-6.49c-.58,0-1.05,.48-1.05,1.06v12.73c0,.59,.47,1.06,1.05,1.06h7.39v1.22h-1.27c-.83,0-1.5,.68-1.5,1.52v.28c0,.19,.15,.34,.34,.34h8.63c.19,0,.34-.15,.34-.34v-.28c0-.84-.67-1.52-1.5-1.52h0Zm-3.16-6.23c-2.29,0-4.76-1.3-4.77-4.17,0-1.8,.72-2.78,1.65-4.02,.13-.17,.26-.35,.39-.53,.15-.2,.28-.39,.4-.58,0,0,0,0,0,0,.14-.2,.26-.4,.38-.59h3.89c.12,.19,.24,.39,.38,.59,0,0,0,0,0,0,.12,.18,.25,.37,.4,.58,.13,.18,.26,.36,.39,.53,.92,1.25,1.65,2.23,1.65,4.02,0,2.86-2.48,4.17-4.77,4.17h0Zm2.13-11.04c.12,0,.23,.1,.23,.23s-.1,.23-.23,.23h-4.25c-.12,0-.23-.1-.23-.23s.1-.23,.23-.23h4.25Zm-4.82-3.28c.08-.11,.32-.04,.39-.02,.23,.07,.38,.2,.53,.32h.01c.21,.19,.45,.35,.73,.31,.2-.03,.38-.15,.53-.37,.19-.27,.37-.43,.5-.43s.31,.16,.5,.43c.15,.22,.33,.34,.53,.37,.28,.04,.52-.12,.73-.3h.01c.14-.13,.29-.26,.53-.33,.07-.02,.31-.09,.39,.02,.14,.19,.11,.97-.94,2.59h-3.49c-1.05-1.63-1.08-2.41-.94-2.59h0Zm1.48,19.34h2.42v1.22h-2.42v-1.22h0Zm-2.76,2.67c.03-.43,.39-.77,.82-.77h6.31c.43,0,.79,.34,.82,.77h-7.94Zm5.82-15.65l-.28,.19-.54-.23-.06-.33c-.05-.24-.26-.42-.5-.42h-.93c-.24,0-.46,.18-.5,.42l-.06,.33-.54,.23-.28-.19c-.2-.14-.48-.11-.65,.06l-.66,.67c-.17,.18-.2,.45-.06,.66l.18,.28-.22,.55-.33,.06c-.24,.05-.41,.26-.41,.51v.95c0,.25,.17,.46,.41,.51l.33,.06,.22,.55-.18,.28c-.14,.21-.11,.48,.06,.66l.66,.67c.17,.18,.45,.2,.65,.06l.28-.19,.54,.23,.06,.33c.05,.24,.26,.42,.5,.42h.93c.24,0,.46-.18,.5-.42l.06-.33,.54-.23,.28,.19c.2,.14,.48,.11,.65-.06l.66-.67c.17-.18,.2-.45,.06-.66l-.18-.28,.22-.55,.33-.06c.24-.05,.41-.26,.41-.51v-.95c0-.25-.17-.46-.41-.51l-.33-.06-.22-.55,.18-.28c.14-.21,.11-.48-.06-.66l-.66-.67c-.17-.18-.45-.2-.65-.06h0Zm.49,1.76l.36,.89c.04,.11,.14,.18,.25,.21l.37,.07v.67l-.37,.07c-.11,.02-.2,.1-.25,.21l-.36,.89c-.04,.11-.03,.23,.03,.32l.21,.32-.47,.47-.31-.21c-.09-.06-.21-.08-.32-.03l-.88,.37c-.11,.04-.18,.14-.2,.25l-.07,.37h-.66l-.07-.37c-.02-.11-.1-.21-.2-.25l-.88-.37c-.11-.04-.23-.03-.32,.03l-.31,.21-.47-.47,.21-.32c.06-.1,.08-.22,.03-.32l-.36-.89c-.04-.11-.14-.18-.25-.21l-.37-.07v-.67l.37-.07c.11-.02,.2-.1,.25-.21l.36-.89c.04-.11,.03-.23-.03-.32l-.21-.32,.47-.47,.31,.21c.09,.06,.21,.08,.32,.03l.88-.37c.11-.04,.18-.14,.2-.25l.07-.37h.66l.07,.37c.02,.11,.1,.21,.2,.25l.88,.37c.11,.04,.23,.03,.32-.03l.31-.21,.47,.47-.21,.32c-.06,.1-.08,.22-.03,.32h0Zm-2.34-.74c-1.22,0-2.22,1.01-2.22,2.25s1,2.25,2.22,2.25,2.22-1.01,2.22-2.25-.99-2.25-2.22-2.25h0Zm0,3.8c-.85,0-1.54-.7-1.54-1.56s.69-1.56,1.54-1.56,1.54,.7,1.54,1.56-.69,1.56-1.54,1.56h0Zm12.82,2.29h-.49v-.21c0-.19-.15-.34-.34-.34s-.34,.15-.34,.34v.21h-1.05v-.21c0-.19-.15-.34-.34-.34s-.34,.15-.34,.34v.21h-1.05v-.21c0-.19-.15-.34-.34-.34s-.34,.15-.34,.34v.21h-1.05v-.21c0-.19-.15-.34-.34-.34s-.34,.15-.34,.34v.21h-.49c-.74,0-1.34,.61-1.34,1.36v4.97c0,.49,.17,.91,.51,1.25l.47,.48c.34,.34,.75,.52,1.23,.52h6c.74,0,1.34-.61,1.34-1.36v-5.85c0-.75-.6-1.36-1.34-1.36h0Zm-6.87,.69h.49v.05c0,.19,.15,.34,.34,.34s.34-.15,.34-.34v-.05h1.05v.05c0,.19,.15,.34,.34,.34s.34-.15,.34-.34v-.05h1.05v.05c0,.19,.15,.34,.34,.34s.34-.15,.34-.34v-.05h1.05v.05c0,.19,.15,.34,.34,.34s.34-.15,.34-.34v-.05h.49c.36,0,.66,.3,.66,.67v.39h-8.2v-.39c0-.37,.3-.67,.66-.67h0Zm-.35,6.4s-.05-.06-.08-.09c.03,0,.06,0,.1,0h.38c.09,0,.16,.07,.16,.16v.38s0,.06,0,.1c-.03-.02-.06-.05-.08-.08l-.47-.48h0Zm7.22,.8h-5.66c-.18,0-.33-.15-.33-.33v-.38c0-.47-.38-.85-.84-.85h-.38c-.18,0-.33-.15-.33-.33v-3.54h8.2v4.77c0,.37-.3,.67-.66,.67h0Zm-1.69-4.11l-1.26,1.28,1.26,1.28c.13,.13,.13,.35,0,.49-.07,.07-.15,.1-.24,.1s-.17-.03-.24-.1l-1.26-1.28-1.26,1.28c-.13,.13-.35,.13-.48,0s-.13-.35,0-.49l1.26-1.28-1.26-1.28c-.13-.13-.13-.35,0-.49,.13-.13,.35-.13,.48,0l1.26,1.28,1.26-1.28c.13-.13,.35-.13,.48,0,.13,.13,.13,.35,0,.49h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcmInfographic);
export default __webpack_public_path__ + "static/media/RcmInfographic.44dad78ac0dba99630f869b4ad1a91e6.svg";
export { ForwardRef as ReactComponent };